import React, { useState } from 'react';
import propTypes from 'prop-types';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { get } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { UiFieldset } from 'src/ui';

import { isDataComplete, isDataValueComplete } from '../services';

export function DataIterator({
  title,
  dataMap,
  items,
  itemKey,
  subtitle,
  viewLink,
}) {
  const [expanded, setExpanded] = useState({});

  const data = items instanceof Array ? items : [items];
  return (
    <UiFieldset title={title} className="data-iterator">
      <Columns isMultiline>
        {data.map(item => {
          const key = get(item, itemKey, 'loading');
          const hasSections = subtitle != null;
          const isExpanded = !!expanded[key];
          const isComplete = isDataComplete(item, dataMap);

          return (
            <Column isSize="full" key={key}>
              <div className="panel">
                {hasSections && (
                  <p
                    className={classNames(
                      'panel-heading',
                      isComplete ? null : 'panel-heading-incomplete'
                    )}
                  >
                    <FontAwesomeIcon
                      icon={[
                        'fal',
                        isExpanded ? 'minus-circle' : 'plus-circle',
                      ]}
                      size="1x"
                      color="#acb2d1"
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        setExpanded({ ...expanded, [key]: !isExpanded })
                      }
                    />
                    &nbsp;&nbsp;
                    {typeof subtitle === 'string'
                      ? get(item, subtitle, '')
                      : subtitle(item)}
                    {viewLink != null && (
                      <Link
                        to={`${viewLink}${key}`}
                        className={classNames(
                          'panel-link',
                          isComplete ? null : 'panel-heading-incomplete'
                        )}
                      >
                        View&nbsp;
                        <FontAwesomeIcon icon={['fal', 'external-link']} />
                      </Link>
                    )}
                  </p>
                )}
                {(!hasSections || isExpanded) &&
                  dataMap.map(
                    ({ label, value, required, filter = value => value }) => {
                      const valueString = filter(get(item, value, ''), item);
                      const isValueComplete =
                        !required || isDataValueComplete(valueString);

                      return (
                        <div
                          className={classNames(
                            'panel-block',
                            hasSections ? 'panel-child' : null
                          )}
                          key={label}
                        >
                          <Columns>
                            <Column
                              isSize="1/3"
                              className={classNames(
                                'has-text-grey-medium-dark',
                                'data-label',
                                isValueComplete
                                  ? null
                                  : 'panel-heading-incomplete'
                              )}
                            >
                              {label}
                            </Column>
                            <Column className="data-value">
                              {valueString}
                            </Column>
                          </Columns>
                        </div>
                      );
                    }
                  )}
              </div>
            </Column>
          );
        })}
      </Columns>
    </UiFieldset>
  );
}

DataIterator.defaultProps = {
  subtitle: null,
  viewLink: null,
};

DataIterator.propTypes = {
  title: propTypes.string.isRequired,
  dataMap: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string.isRequired,
      value: propTypes.string.isRequired,
      filter: propTypes.func,
    })
  ).isRequired,
  items: propTypes.oneOfType([propTypes.array, propTypes.object]).isRequired,
  itemKey: propTypes.string.isRequired,
  subtitle: propTypes.oneOfType([propTypes.string, propTypes.func]),
  viewLink: propTypes.string,
};
